export const themeJson = {
  "themeName": "layered",
  "colorPalette": "light",
  "isPanelless": false,
  "backgroundImage": "", // Можно добавить паттерн, если есть
  "backgroundOpacity": 1,
  "backgroundImageAttachment": "scroll",
  "backgroundImageFit": "cover",
  "cssVariables": {
    // --- ГЕОМЕТРИЯ ---
    "--sjs-corner-radius": "16px",
    "--sjs-base-unit": "8px",

    // --- ТЕНИ (Глубокие, чтобы парить над синим фоном) ---
    "--sjs-shadow-small": "0px 4px 12px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-medium": "0px 8px 24px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-large": "0px 15px 40px rgba(0, 0, 0, 0.4)",
    "--sjs-editor-background": "#FFFFFF",
    "--sjs-editorpanel-backcolor": "#FFFFFF",
    // 2. Делаем текст внутри инпутов темным
    "--sjs-font-editorfont-color": "#111827",
    // 3. Цвет плейсхолдера (подсказки) - серый
    "--sjs-font-editorfont-placeholder-color": "#9CA3AF",
    // 4. Граница инпута
    // SurveyJS использует box-shadow вместо border.
    // Делаем имитацию серой границы в 1px.
    "--sjs-shadow-inner": "0px 0px 0px 1px #D1D5DB",
    // 5. (Опционально) Если хотите, чтобы инпуты были менее скругленными, чем сама карточка
    "--sjs-editorpanel-cornerRadius": "8px",
    // --- ГРАНИЦЫ (Важно для белых полей!) ---
    // Делаем явную серую границу для инпутов, так как фон теперь белый
    "--sjs-border-default": "#D1D5DB",
    "--sjs-border-light": "#E5E7EB",
    "--sjs-border-inside": "rgba(0, 0, 0, 0.1)",

    // --- ФОНОВЫЕ ЦВЕТА ---
    // ГЛАВНЫЙ ФОН СТРАНИЦЫ (Темно-синий Brand Blue)
    "--sjs-general-backcolor-dim": "#023048",
    "--sjs-general-backcolor-dim-light": "#034363",
    "--sjs-general-backcolor-dim-dark": "#012030",

    // ФОН КАРТОЧКИ (Белый)
    "--sjs-general-backcolor": "#FFFFFF",

    // ФОН ИНПУТОВ (Сделали Белым вместо Серого для "воздуха")
    "--sjs-general-backcolor-dark": "#FFFFFF",

    // --- ЦВЕТА ТЕКСТА ---
    "--sjs-general-forecolor": "#111827", // Почти черный для контраста
    "--sjs-general-forecolor-light": "#6B7280", // Серый для подсказок
    "--sjs-general-dim-forecolor": "#FFFFFF", // Белый текст для заголовков вне карточек
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.7)",

    // --- АКЦЕНТНЫЙ ЦВЕТ (Красный) ---
    "--sjs-primary-backcolor": "#C1111E",
    "--sjs-primary-backcolor-dark": "#960D17",

    // Фон при фокусе/наведении на инпут - очень бледный голубой (вместо красного)
    // Это делает форму спокойнее
    "--sjs-primary-backcolor-light": "rgba(2, 48, 72, 0.05)",

    "--sjs-primary-forecolor": "#FFFFFF",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",

    // --- ВТОРИЧНЫЙ ЦВЕТ ---
    "--sjs-secondary-backcolor": "#659ABA",
    "--sjs-secondary-backcolor-light": "rgba(101, 154, 186, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(101, 154, 186, 0.25)",
    "--sjs-secondary-forecolor": "#FFFFFF",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",

    // --- ОСТАЛЬНЫЕ ЦВЕТА (Оставляем как есть) ---
    "--sjs-special-red": "rgba(229, 10, 62, 1)",
    "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
    "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-green": "rgba(25, 179, 148, 1)",
    "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
    "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-blue": "rgba(67, 127, 217, 1)",
    "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
    "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",

    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0)",

    /* --- ШРИФТЫ (Оставляем как есть) --- */
    "--sjs-article-font-xx-large-fontFamily": "'Roboto Slab', serif",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-x-large-fontFamily": "'Roboto Slab', serif",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-large-fontFamily": "'Roboto Slab', serif",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-medium-fontFamily": "'Roboto Slab', serif",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-default-fontFamily": "'Roboto', sans-serif",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-fontSize": "18px",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
  },
  "header": {
    "height": 56,
    "textAreaWidth": 502,
  },
  "headerView": "advanced",
};